import React, { useState, useEffect } from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaWhatsapp,
  FaArrowUp,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  HiOutlinePhone,
  HiOutlineMail,
  HiOutlineLocationMarker,
} from "react-icons/hi";
import { Link } from "react-router-dom";

const Footer = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <footer className="footer">
      {/* ================= MAIN GRID ================= */}
      <div className="footer-container">
        {/* FOLLOW US */}
        <section className="footer-column">
          <h3>Follow Us</h3>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/p/infodeltasys-100077470740495/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF /> Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/infodeltasys_global/"
                target="_blank"
                rel="noreferrer"
              >
                <FaTwitter /> Twitter
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/infodeltasys-software-solution-opc-pvt-ltd-564185219/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedinIn /> LinkedIn
              </a>
            </li>
          </ul>
        </section>

        {/* ABOUT */}
        <nav className="footer-column">
          <h3>About Us</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/software-training">Training</Link></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </nav>

        {/* SERVICES */}
        <nav className="footer-column">
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/services">E-commerce Website</Link></li>
            <li><Link to="/mobile-app-development-2">Android App</Link></li>
            <li><Link to="/web-design">Website Redesign</Link></li>
            <li><Link to="/web-development-service-company-lucknow">Web Development</Link></li>
            <li><Link to="/seo-lucknow">SEO</Link></li>
            <li><Link to="/software-training">IT Training Program</Link></li>
          </ul>
        </nav>

        {/* CONTACT */}
        <section className="footer-column">
          <h3>Reach Out</h3>
          <ul>
            <li>
              <a href="mailto:info@infodeltasys.com">
                <HiOutlineMail /> info@infodeltasys.com
              </a>
            </li>
            <li>
              <a href="tel:+918090387120">
                <HiOutlinePhone /> +91-8090387120
              </a>
            </li>
            <li>
              <a href="tel:+916387722743">
                <HiOutlinePhone /> +91-6387722743
              </a>
            </li>
            <li>
              <a href="tel:+919889685276">
                <HiOutlinePhone /> +91-9889685276
              </a>
            </li>
          </ul>
        </section>
      </div>

      {/* ================= ADDRESS ================= */}
      <address className="footer-addresses">
        <h1>Address</h1>

        <div className="address-column">
          <h4>Varanasi</h4>
          <p>
            <HiOutlineLocationMarker />
            B-29/43 Sankat Mochan, Lanka, Varanasi 221001
          </p>
        </div>

        <div className="address-column">
          <h4>Lucknow</h4>
          <p>
            <HiOutlineLocationMarker />
            L-111 Sector-L, Ashiyana, Lucknow 226012
          </p>
        </div>

        <div className="address-column">
          <h4>Pune</h4>
          <p>
            <HiOutlineLocationMarker />
            Hadapsar, Pune 411028
          </p>
        </div>

        {/* <div className="address-column">
          <h4>Europe</h4>
          <p>
            <HiOutlineLocationMarker />
            Zevenhuizen, Nederland
          </p>
        </div> */}
      </address>

      {/* ================= BOTTOM ================= */}
      <div className="footer-bottom">
        © 2026 InfoDeltaSys Software Solutions (OPC) Pvt. Ltd.
      </div>

      {/* FLOATING BUTTONS */}
      <a
        href="https://wa.me/916387722743"
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
      >
        <FaWhatsapp />
      </a>

      <a href="tel:+916387722743" className="call-float">
        <FaPhoneAlt />
      </a>

      {showTop && (
        <button
          className="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Scroll to top"
        >
          <FaArrowUp />
        </button>
      )}
    </footer>
  );
};

export default Footer;
